import React from 'react';
import { connect } from 'react-redux';
import ExpenseItem from './ExpenseItem';
import selectExpenses from '../../selectors/expenses';

const ExpenseList = (props) => (
  <div className="content-container">
    <div className="list-header">
      <div className="show-for-mobile">Expenses</div>
      <div className="show-for-desktop">Expense</div>
      <div className="show-for-desktop">Amount</div>
    </div>
    <div className="list-body">
      {props.expenses.length === 0 ? (
        <div className="list-item list-item--message">
          <p>No expenses</p>
        </div>
      ) : (
        props.expenses.map((expense) => (
          <ExpenseItem key={expense.id} {...expense} />
        ))
      )}
    </div>    
  </div>
);

const mapStateToProps = (state) => ({
  expenses: selectExpenses(state.expenses, state.expenseFilters)
});

export default connect(mapStateToProps)(ExpenseList);